// extracted by mini-css-extract-plugin
export default {"Logo":"LogoDark_Logo__M2abZ"};